import Vue from 'vue'
import currentUserMixin from './currentUserMixin'
import commonMixin from './commonMixin'
import hookMixin from './hookMixin'

// список глобальных примесей (доступны из всех компонентов)

const mixins = {
  currentUserMixin,
  commonMixin,
  hookMixin
}

Object.keys(mixins).forEach(name => {
  Vue.mixin(mixins[name])
})
